const ApplicationName = 'Reports';

const Links = Object.freeze({
    reportingAndPerformanceHeader: 'Reporting and performance header clicked',
    tpamsReportsNavigationLink: 'Reports navigation clicked',
    reportCountAndLastAddedDate: 'Report count and last added date clicked',
    showReportsLink: 'Show reports clicked',
    tryAgainLink: 'Try again clicked',
    downloadReport: (reportName: string) => `Downloaded - ${reportName}`,
    kbReportLink: (kbName: string, period: string) => `${kbName} selected of ${period}`,
    tpamsBreadcrumb: 'Clicked on reports breadcrumb'
});

const Components = Object.freeze({
    TPAMSReportsDashboardTile: 'Reports card',
    TPAMSReports: 'Reports list page',
    TPAMSMonthlyReports: 'Monthly reports list page'
});

export {
    ApplicationName,
    Links,
    Components
};
